import React from "react";
//#region types
import { TodoCardProps } from "models/propTypes/todoPropTypes";
//endregion
//#region components
import { QualifiedShareDividend } from "components/qualifiedShareDividend";
//#endregion

const QualifiedShareDividendsTodoToApprove: React.FC<TodoCardProps> = (props) => {
  const qualifiedShareDividend = props.item.qualifiedShareDividend;

  return qualifiedShareDividend ? (
    <QualifiedShareDividend qualifiedShareDividend={qualifiedShareDividend} reloadHandler={props.onActionSuccess} />
  ) : (
    <></>
  );
};

export default QualifiedShareDividendsTodoToApprove;
